import React from "react";
import cn from "classnames";
import { Textfit } from "react-textfit";
import styles from "./Answers.module.css";
import withForceRerender from "../../HOC/withForceRerender";

import SimpleAnswerPicture from "../../images/answer-picture.png";
import AnswerImage from "../../images/answer.png";

const AnswerWithImage = ({
  isAnswerDown,
  panelImage,
  answerImage,
  answerImageAlt,
  answerText,
}) => {
  return (
    <div className={cn(styles.answerWrapper, styles.answerWithIconWrapper)}>
      <div
        className={cn(
          styles.answerInner,
          isAnswerDown ? styles.answerDown : ""
        )}
      >
        <img
          src={isAnswerDown ? SimpleAnswerPicture : panelImage}
          alt="answer panel"
          className={styles.answerPanelImage}
        />
        <div className={styles.answerWithIconContent}>
          {answerImage && <img src={answerImage} alt={answerImageAlt} />}
          {answerText && (
            <Textfit min={12} max={22} className={styles.answerWithIconText}>
              <p>{answerText}</p>
            </Textfit>
          )}
        </div>
      </div>
    </div>
  );
};

export const AnswerWithImageMemoized = React.memo(
  withForceRerender(AnswerWithImage)
);

export function Answer({ isAnswerDown, panelImage, answerText }) {
  return (
    <div className={styles.answerWrapper}>
      <div
        className={cn(
          styles.answerInner,
          isAnswerDown ? styles.answerDown : ""
        )}
      >
        <img
          src={isAnswerDown ? AnswerImage : panelImage}
          alt="answer panel"
          className={styles.answerPanelImage}
        />
        <Textfit mode="multi" className={styles.answerText} min={24} max={50}>
          <p>{answerText}</p>
        </Textfit>
      </div>
    </div>
  );
}

export const AnswerMemoized = React.memo(withForceRerender(Answer));
